import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';

import { LogoImage } from '../common/LogoImage';
import { ITitleViewProps, TitleView } from './TitleView';

const Container = styled(View)({
  alignItems: 'center',
  justifyContent: 'center',
});

const Logo = styled(LogoImage)({
  width: 146,
  height: 44,
});

interface ITextContainerStyleProps {
  hasTopText: boolean;
}

const TextContainer = styled(View)(
  (props: ITextContainerStyleProps) => ({
    pt: props.hasTopText ? '$8' : '$9',
  }),
);

export interface ILogoViewProps extends ITitleViewProps {
  title: string;
}

export function LogoView(props: ILogoViewProps) {
  const hasTopText = !!props.topText;

  return (
    <Container>
      <Logo />
      <TextContainer hasTopText={hasTopText}>
        <TitleView {...props} />
      </TextContainer>
    </Container>
  );
}
